
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtnNameOfGod from 'components/root/partials/header/ShortHeaderWithBackBtnNameOfGod';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';

const Rules = () => {

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtnNameOfGod />
                
                
                <p className={ruleStyles['text-justify']}>
                    شرکت سهامی خاص فن آوران و نوآوران دکتر بیست (Dr20)، به منظور پیشگیری از بیماری ها، مشاوره پزشکی و درمان بیماری‌ها با روش های نوین و های تک (High Tech) تأسیس گردیده است که انشاءالله عمدۀ درآمد خالص آن صرف امور خیریه (درمانی و غیردرمانی) براساس اساسنامۀ شرکت خواهد شد.
                </p>

                <div className={[formStyles['title-2'], formStyles['text-right'], sharedStyles['text-primary']].join(' ')}>
                    آئین نامه استفاده از خدمات مشاوره پزشکی دکتر بیست (Dr20)
                </div>

                <ul className={[ruleStyles['pr-[16px]'], ruleStyles['text-justify']].join(' ')}>
                    <li>
                        <span className={[ruleStyles['font-weight-500'], sharedStyles['text-primary']].join(' ')}>تعریف کاربر: </span>
                        <p className={ruleStyles['text-justify']}>
                            کاربر به شخصی گفته می‌شود که با اطلاعات کاربری خود که در فرم ثبت نام درج کرده است، نسبت به استفاده از خدمات دکتر بیست (Dr20) اقدام می کند. کاربران دکتر بیست (Dr20) به سه دسته :   A) بیماران  B) پزشکان  C) مراکز پزشکی تقسیم می شوند. 
                        </p>
                    </li>
                    <li>
                        <span className={[ruleStyles['font-weight-500'], sharedStyles['text-primary']].join(' ')}>محتوا : </span>
                        <p className={ruleStyles['text-justify']}>
                            دکتر بیست (Dr20)نهایت تلاش و دقت را در راستای ارائه تمامی سرویس های خود می کند و به منظور تولید محتوا از منابع و مراجع اصیل و پزشکان نخبه دانشگاهی استفاده می کند.
                        </p>
                        <p className={ruleStyles['text-justify']}>
                            سایت دکتر بیست (Dr20) ممکن است دارای سرویس هایی با قابلیت مشارکت عمومی موسوم به سرویس های جمعی، همچون اتاق گفتگو، تابلوی اعلانات، تالار گفتگو، نقد، گروه های خبری، شبکه دوستان و سرویس های دیگری باشد که برای تسهیل ارتباط شما با دیگران (چه در مقیاس عمومی مثل تالار گفتگو و چه در مقیاس خصوصی مثل شبکه خصوصی دوستان) ارائه می شود. شما توافق می کنید که از سرویس های جمعی، فقط برای ثبت، ارسال و دریافت پیام هایی استفاده کنید که مناسب و مرتبط با آن سرویس خاص باشد.
                        </p>
                    </li>
                    <li>
                        <span className={[ruleStyles['font-weight-500'], sharedStyles['text-primary']].join(' ')}>قوانین عمومی :</span>
                        <p className={ruleStyles['text-justify']}>
                            توجه داشته باشید کلیه اصول و رویه های دکتر بیست (Dr20)منطبق با قوانین جمهوری اسلامی ایران است. درصورتی که در قوانین مندرج ، رویه ها و سرویس های دکتر بیست (Dr20)تغییراتی در آینده ایجاد شود، در همین صفحه منتشر و به روزرسانی می شود و شما توافق می کنید که استفاده مستمر شما از سایت به معنی پذیرش هرگونه تغییر است.
                        </p>
                        <p className={ruleStyles['text-justify']}>
                            هنگامی که شما از سرویس های ارتباطی و خدمات دکتر بیست (Dr20)استفاده می کنید، این ارتباطات به صورت الکترونیکی انجام می‌شود و درصورتی که درخواست شما با رعایت کلیه اصول و رویه ها باشد، شما موافقت می کنید که دکتر بیست (Dr20)به صورت مجازی (صوتی، تصویری و یا متنی) از طریق اپلیکیشن های واتساپ، روبیکا، ایتا و بله و یا از طریق وبسایت و اپلیکیشن دکتر بیست، به درخواست شما پاسخ دهد.
                        </p>
                        <p className={ruleStyles['text-justify']}>
                            همچنین شماره تلفنی که کاربر در پروفایل خود ثبت می کند، تنها تلفن رسمی و مورد تایید کاربر است و تمام مکاتبات و پاسخ های شرکت از طریق آن صورت می گیرد.
                        </p>
                        <p className={ruleStyles['text-justify']}>
                            ورود شما بعنوان کاربر به وب سایت دکتر بیست (www.Dr20.org) هنگام استفاده از پروفایل شخصی و نرم افزارهای کاربردی سایر خدمات ارائه شده توسط دکتر بیست (Dr20)، به معنای آگاه بودن و پذیرفتن شرایط و قوانین دکتر بیست (Dr20) است.
                        </p>
                    </li>
                    <li>
                        <span className={[ruleStyles['font-weight-500'], sharedStyles['text-primary']].join(' ')}>شرایط و قوانین استفاده از خدمات مشاوره پزشکی دکتر بیست (Dr20) : </span>
                        <ul className={[ruleStyles['pr-[16px]'], ruleStyles['text-justify']].join(' ')}>
                            <li>
                                سرویس مشاوره دکتر بیست (Dr20) ، یک بستر مجازی امن برای ایجاد ارتباط بین کاربر و پزشک جهت مطرح کردن سوالات پزشکی است. در این سرویس، از تمامی امکانات نرم افزاری و          سخت افزاری روز دنیا استفاده شده است تا کاربر با خیال راحت و با امنیت بالا با مشاورۀ پزشکی اصولی و حرفه ای، سلامتی خود را بازیابد.
                            </li>
                            <li>
                                <span className={[ruleStyles['font-weight-800'], sharedStyles['text-red']].join(' ')}>خدمات پزشکی دکتر بیست (Dr20) شامل خدمات پزشکی اورژانسی نیست و جهت دریافت خدمات اورژانسی، باید با اورژانس 115 تماس بگیرید. </span>
                                <p>
                                    بیماران اورژانسی که شامل خدمات پزشکی دکتر بیست (Dr20) نمی شوند؛ شامل موارد زیر هستند: 
                                </p>
                                <ul className={[ruleStyles['pr-[16px]'], ruleStyles['text-justify']].join(' ')}>
                                    <li>
                                        الف) بیماران دارای علائم سکته قلبی (MI) ، سکته مغزی (CVA)
                                    </li>
                                    <li>
                                        ب) بیماران دارای خونریزی شدید در هر ناحیه ای از بدن (Sever Bleeding)
                                    </li>
                                    <li>
                                        ج ) بیماران دارای شکستگی ، به خصوص ران و ساق پا (چون شانس آمبولی چربی دارند)
                                    </li>
                                    <li>
                                        د )  بیماران حمله حاد آسم و تنگی نفس شدید (Acute Attack of Asthma )
                                    </li>
                                    <li>
                                        هـ) بیماران درد حاد شکمی 
                                        <br />
                                        (Acute Abdominal Pain)
                                        <br />
                                        که احتمال آپاندیسیت و التهاب حاد کیسه صفرا 
                                        <br />
                                        (Acute Cholecystitis)
                                        <br />
                                        وجود دارد و ...
                                    </li>
                                    <li>
                                        و ) بیماران دارای کاهش سطح هوشیاری 
                                        <br />
                                        (Decreased Level of Consciousness )
                                        <br />
                                        ، عدم تعادل و . . . 
                                    </li>
                                    <li>
                                        ز ) بیماران دارای نامنظمی ضربان قلب یا Arrythmia 
                                    </li>
                                </ul>
                                   این مواردفوق الذکر در بیماران اورژانسی ، شامل خدمات پزشکی دکتر بیست (Dr20) نمی شود.
                            </li>
                            <li>
                                در تمامی پلن های مشاوره، کاربر می تواند با ارسال متن، صوت، تصاویر اطلاعات پزشکی (شامل جواب آزمایش، جواب سونو، CT و MRI ، تراکم استخوان، PET Scan، نوار گوش (ادیو متری)، نوار ریه (اسپیرو متری) ، نوار مغز (EEG)، جواب اندوسکوپی و  سایر مدارک پزشکی ) با پزشکان نخبۀ Dr20، ارتباط برقرار کند. 
                            </li>
                            <li>
                                هرگونه بی احترامی به پزشکان Dr20 ، برابر قانون پیگرد قانونی خواهد داشت و همچنین ارائه خدمات به فرد خاطی، متوقف خواهد شد و شخص خاطی، در بلاک لیست Dr20 قرار خواهد گرفت.
                            </li>
                            <li>
                                در هر مشاوره پزشکی ، گفتگوی کاربر و پزشک حول یک موضوع مشخص و یک بیماری تعیین شده، خواهد بود و چنانچه کاربر قصد مطرح کردن موضوعات مختلف و متنوع را دارد، لازم است در مشاوره های جدید بعدی، به موضوعات جدید بپردازد. 
                            </li>
                            <li>
                                درصورت عدم پاسخگویی پزشک Dr20 در زمان مقرر حداکثر 5 ساعت، وجه پرداختی بصورت کامل (100%) به شما بازگردانده می‌شود و یا سوالتان به پزشک دیگر، ارجاع داده می‌شود.
                            </li>
                            <li>
                                زمان استراحت پزشکان و کادر Dr20، بین ساعت 10 شب تا 8 صبح خواهد بود. و در زمان مذکور ، درخواست های مشاوره پزشکی و صدور نسخۀ الکترونیک، در سامانه جامع دکتر بیست (Dr20)، ذخیره می شوند و براساس نوبت ، پاسخ داده خواهند شد.
                            </li>
                            <li>
                                پزشکان نخبۀ دکتر بیست (Dr20) براساس استانداردهای علمی و اخلاقی انتخاب شده اند ولی مسئولیت هرگونه خطا و قصور پزشکی احتمالی و سهوی براساس قوانین سازمان محترم نظام پزشکی ایران، برعهدۀ پزشک تجویز کنندۀ نسخه و یا خدمات پزشکی می باشد.
                            </li>
                            <li>
                                تمامی پزشکان نخبۀ دکتر بیست (Dr20)، دارای بیمۀ مسئولیت حرفه ای می باشند.
                            </li>
                            <li>
                                لازم به ذکر است اطلاعات پزشکی بیماران (نوع بیماری و نام داروهای مصرفی شخص) کاملاً محرمانه بوده و فقط خودکاربر و پزشک مشاور دکتر بیست (Dr20) به آن دسترسی دارند و نگرانی در این رابطه به هیچ وجه وجود ندارد.
                            </li>
                            <li>
                                هزینه تعرفه ویزیت و خدمات پزشکی طبق تعرفه ابلاغی هیئت محترم دولت در سال 1404 می باشد و ضمناً بیمار می تواند در حین مراجعه  به داروخانه و یا مراکز پاراکلینیک (داروخانه، مراکز تصویربرداری، سونو گرافی، آزمایشگاه‌های طبی و . . . ) از حق بیمه خود طبق قانون بیمه های پایه و تکمیلی استفاده کند.
                            </li>
                            <li>
                                مسئولیت صحت اطلاعات بیمار شامل (نوع بیماری، داروهای مصرفی، حساسیت های دارویی، جواب آزمایشات پاراکلینیک) برعهده خود کاربر(متقاضی خدمات پزشکی دکتر بیست Dr20) می باشد.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <span className={[ruleStyles['font-weight-500'], sharedStyles['text-primary']].join(' ')}>شرایط غیرقابل پیش بینی :</span>
                        <p className={ruleStyles['text-justify']}>
                            تمامی شرایط و قوانین مندرج، در شرایط عادی قابل اجرا است و درصورت بروز هرگونه از موارد غیرقابل پیش بینی، (اعم از زلزله، آتش سوزی، سیل، جنگ و موارد دیگر) دکتر بیست (Dr20)  هیچگونه مسئولیتی ندارد. 
                        </p>
                    </li>
                </ul>
            </div>
                
        </div>

    );
}

export default Rules;